import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';

export const ResetPasswordButton = styled(LoadingButton)(({ theme }) => ({
  marginLeft: theme.spacing(2)
})); 